export const app = {
  connectToYourWhatsappNumber: 'あなたのWhatsApp番号に接続',
  connectYourWhatsappBotWithYourWhatsappNumber: 'WhatsAppボットをあなたのWhatsApp番号に接続',
  connect: '接続',
};
